import gql from "graphql-tag";

export const GET_FUNDS = gql`
    query getFunds {
        funds: parties(filter: { typeIn: [Fund] }) {
            _id
            name
            accountingCurrency
            fundInfo {
                riskLevel
                classes {
                    enabled
                    startDate
                }
            }
        }
    }
`;

export const GET_FX_VALUATIONS = gql`
    query getFxValuations($date: GraphQLSwedenDate!) {
        fxValuations(date: $date) {
            name
            date
            price
            currency
        }
    }
`;

export const GET_LAST_NAV = gql`
    query getLastNav($fundId: GraphQLObjectId) {
        lastNav: navs(clientId: $fundId, lastOnly: true) {
            _id
            clientId
            date
            comment
            frontOfficeNav
            createTimestamp
            status
            updateUserId
            fundRiskLevel
            absLowTolerancePercent
            absHighTolerancePercent
            publishedTo {
                key
                timestamp
                userId
            }
            data {
                classes {
                    instrumentId
                    name
                    navBeforeAdjustmentsBeforeOrders
                    managementFee
                    dividendPaid
                    fxHedge
                    fxRate
                    adjustmentAmount
                    navAfterAdjustmentsBeforeOrders
                    navAfterAdjustmentsAfterOrders
                    navCurrency
                    navPerUnit
                    navPerUnitReturn1D
                    unitsAfterOrders
                    unitsBeforeOrders
                    weight
                }
                adjustmentAmountPositions {
                    instrumentId
                    name
                    accountId
                    value
                    currency
                    fxValuationDate
                    valuationDate
                    fxRate
                    quantity
                }
                positions {
                    instrumentId
                    name
                    accountId
                    value
                    currency
                    fxValuationDate
                    valuationDate
                    fxRate
                    quantity
                }
                orders {
                    amount
                    carryOwnTransactionCost
                    currency
                    instrumentId
                    isin
                    name
                    orderId
                    transactionType
                    units
                    valueDate
                }
                transactions {
                    accountId
                    adjustmentAmount
                    adjustmentShares
                    amount
                    currency
                    externalId
                    instrumentId
                    isin
                    name
                    price
                    accountingCurrency
                    accountingAmount
                    accountingPrice
                    fxRate
                    transactionType
                    units
                    valueDate
                    accountSwitchOrder
                }
            }
        }
    }
`;

export const CALCULATE_NAV = gql`
    query calculateNav($fundId: GraphQLObjectId!, $dateString: GraphQLDateString!) {
        calculateNav(fundId: $fundId, date: $dateString) {
            classes {
                instrumentId
                name
                navBeforeAdjustmentsBeforeOrders
                managementFee
                dividendPaid
                fxHedge
                fxRate
                adjustmentAmount
                navAfterAdjustmentsBeforeOrders
                navAfterAdjustmentsAfterOrders
                navCurrency
                navPerUnit
                navPerUnitReturn1D
                unitsAfterOrders
                unitsBeforeOrders
                weight
                instrument {
                    currency
                }
            }
            adjustmentAmountPositions {
                instrumentId
                name
                accountId
                value
                currency
                fxValuationDate
                valuationDate
                fxRate
                quantity
            }
            positions {
                instrumentId
                name
                accountId
                value
                currency
                fxValuationDate
                valuationDate
                fxRate
                quantity
            }
            orders {
                amount
                carryOwnTransactionCost
                currency
                instrumentId
                isin
                name
                orderId
                transactionType
                units
                valueDate
            }
            transactions {
                accountId
                adjustmentAmount
                adjustmentShares
                amount
                currency
                externalId
                instrumentId
                isin
                name
                accountingCurrency
                accountingAmount
                accountingPrice
                fxRate
                price
                transactionType
                units
                valueDate
                accountSwitchOrder
            }
        }
    }
`;

export const GET_PERFORMANCE = gql`
    query getPerformance($fundId: GraphQLObjectId!, $dateString: GraphQLDateString!) {
        performance(clientId: $fundId, filter: { endDate: $dateString }) {
            series
        }
    }
`;

export const CREATE_NAV = gql`
    mutation createNav($input: NavInput!) {
        createNav(input: $input) {
            _id
        }
    }
`;

export const DELETE_NAV = gql`
    mutation deleteNav($_id: GraphQLObjectId!) {
        deleteNav(_id: $_id)
    }
`;

export const GET_NAVS = gql`
    query getNavs($startDate: GraphQLDateString) {
        navs(startDate: $startDate) {
            _id
            clientId
            client {
                name
            }
            date
            createTimestamp
            status
            updateUserInfo {
                name
            }
            publishedTo {
                key
            }
        }
    }
`;
